import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints.ts';

interface RecallType {
  deviceName: string;
  deviceType: string;
  recallType: string;
}

interface PatientRecall {
  deviceId: string;
  recallDate: string;
  recallClass: string;
  recallStatus: string;
  reasonForRecall: string;
  recallNumber: string;
  type: RecallType;
}

type PatientRecallsResponse = PatientRecall[];

interface GetPatientRecallsParams {
  patientId: string;
}

export const patientRecallsApiSlice = createApi({
  reducerPath: 'patientRecallsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.PatientRecalls || 'PatientRecalls'],
  endpoints: (builder) => ({
    getPatientRecalls: builder.query<PatientRecallsResponse, GetPatientRecallsParams>({
      query: ({ patientId }) => ({
        url: `/patients/${patientId}/recalls`,
        method: 'GET'
      }),
      providesTags: (_result, _error, { patientId }) => [
        { type: API_SLICE.PatientRecalls || 'PatientRecalls', id: patientId }
      ]
    })
  })
});

export const { useGetPatientRecallsQuery, useLazyGetPatientRecallsQuery } = patientRecallsApiSlice;

export type { PatientRecall, RecallType, PatientRecallsResponse, GetPatientRecallsParams };
